import { encore, userService } from '@saucelabs/sl-util-axios';
import { TM_DEFAULT_TEAM_DISPLAY_NAME } from '@saucelabs/sl-util-config';

export const getSubaccounts = (username) => (
  encore.get(`/api/user/${username}/subaccounts`)
);

export const postTransferOrganization = (data) => {
  const formData = new FormData();

  formData.append('organization_name', data.organization_name);
  if (data.teams_assignment) {
    const file = new Blob(
      [data.teams_assignment],
      { type: 'text/csv' },
    );
    formData.append('teams_assignment', file);
  }

  if (data.teams_metadata) {
    const serializedMetadata = Object.entries(data.teams_metadata)
      .filter(([teamName]) => teamName !== TM_DEFAULT_TEAM_DISPLAY_NAME)
      .reduce((acc, [teamName, values]) => ({ // eslint-disable-line no-unused-vars
        ...acc,
        [teamName]: { virtual_devices: values.overall },
      }), {});


    formData.append('teams_metadata', JSON.stringify(serializedMetadata));
  }

  return encore.post(
    '/api/transfer_organization',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
};

export const getTransferStatus = (uuid) => (
  userService.get(`/v1/transfers/${uuid}/status`)
);
